import { render, staticRenderFns } from "./AccidentReportTable.vue?vue&type=template&id=bdaf8b3e&scoped=true"
import script from "./AccidentReportTable.vue?vue&type=script&lang=js"
export * from "./AccidentReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaf8b3e",
  null
  
)

export default component.exports